import { firestore } from 'Backend/config'
import { getDocs, collection, query, where, orderBy } from 'firebase/firestore'
export default async function getbyseries(series) {
    const querySnapshot = await getDocs(query(collection(firestore, `Products/Camera/Camera`),where('Camera_Series','==',series),orderBy('Camera_Resolution','desc')));  
    return querySnapshot
}